const techStack = [
  {
    'Front-end': [
      {
        tech: 'HTML',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg',
      },
      {
        tech: 'CSS',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg',
      },
      {
        tech: 'JavaScipt',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg',
      },
      {
        tech: 'React',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg',
      },
      {
        tech: 'Redux',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg',
      },
      {
        tech: 'Markdown',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/markdown/markdown-original.svg',
      },
      {
        tech: 'Bootstrap',
        image: 'https://img.icons8.com/color/48/000000/bootstrap.png',
      },
    ],
  },
  {
    'Back-end': [
      {
        tech: 'Python',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg',
      },
      {
        tech: 'MySQL',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg',
      },
      {
        tech: 'MongoDB',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg',
      },
      {
        tech: 'NodeJS',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg',
      },
      {
        tech: 'Sequelize',
        image: 'https://seeklogo.com/images/S/sequelize-logo-9A5075DB9F-seeklogo.com.png',
      },
      {
        tech: 'Docker',
        image: 'https://www.docker.com/sites/default/files/d8/2019-07/Moby-logo.png',
      },
    ],
  },
  {
    Testes: [
      {
        tech: 'Jest',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/jest/jest-plain.svg',
      },
      {
        tech: 'RTL',
        image: 'https://testing-library.com/img/octopus-128x128.png',
      },
      {
        tech: 'Mocha',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mocha/mocha-plain.svg',
      },
      {
        tech: 'Chai',
        image: 'https://avatars.githubusercontent.com/u/1515293?s=200&v=4',
      },
      {
        tech: 'Sinon',
        image: 'https://sinonjs.org/assets/images/logo.png',
      },
    ],
  }, {
    Ferramentas: [
      {
        tech: 'Linux',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg',
      },
      {
        tech: 'VSCode',
        image: 'https://www.vectorlogo.zone/logos/visualstudio_code/visualstudio_code-icon.svg',
      },
      {
        tech: 'Slack',
        image: 'https://www.vectorlogo.zone/logos/slack/slack-icon.svg',
      },
      {
        tech: 'Trello',
        image: 'https://www.vectorlogo.zone/logos/trello/trello-icon.svg',
      },
      {
        tech: 'Heroku',
        image: 'https://avatars.githubusercontent.com/u/23211?s=200&v=4',
      },
      {
        tech: 'Vercel',
        image: 'https://www.svgrepo.com/show/327408/logo-vercel.svg',
      },
    ],
  },
];

export default techStack;
